import { SvgType } from './types'

export default function CarePlans({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2857 11.5C16.2857 10.9477 15.838 10.5 15.2857 10.5H8.71428C8.162 10.5 7.71429 10.9477 7.71429 11.5V21H20.5714C21.3571 21 22 20.325 22 19.5V12H16.2857V11.5ZM14.8571 12.75C14.8571 13.1642 14.5214 13.5 14.1071 13.5H9.89286C9.47864 13.5 9.14286 13.1642 9.14286 12.75C9.14286 12.3358 9.47864 12 9.89286 12H14.1071C14.5214 12 14.8571 12.3358 14.8571 12.75ZM20.5714 6H12V4.5C12 3.51 11.5571 3 10.5714 3H3.42857C2.64286 3 2 3.675 2 4.5V19.5C2 20.325 2.64286 21 3.42857 21H6.28571V10.5C6.28571 9.675 6.92857 9 7.71429 9H16.2857C17.0714 9 17.7143 9.675 17.7143 10.5H22V7.5C22 6.675 21.3571 6 20.5714 6ZM10.5714 5.25C10.5714 5.66421 10.2356 6 9.82143 6H4.17857C3.76436 6 3.42857 5.66421 3.42857 5.25C3.42857 4.83579 3.76436 4.5 4.17857 4.5H9.82143C10.2356 4.5 10.5714 4.83579 10.5714 5.25Z"
        fill={fill}
      />
    </svg>
  )
}
